<template>
    <div class="upcoming-programs">
      <div class="static-head">
            <div class="message-container">
                <h1 class="upcoming-programs-title">Register Here</h1>
            </div>
        </div>
        <section class="programs-showcase section">
            <div class="site__centered">
                <h1 class="upcoming-programs__hero"></h1>
                <div class="programs-showcase__list">

                  <ProgramCard
                    v-for="program in programList"
                    :key="program.id"
                    :program="program"
                  />
                </div>

            </div>
        </section>

    </div>
</template>

<script>
import ProgramCard from '@/views/Program/ProgramCard.vue'

import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  components: {
    ProgramCard,
  },
  data: () => ({
    metaData: [],
  }),
  computed: {
    ...mapGetters({
      programList: 'programs/getProgramsList',
    }),
  },
  async mounted() {
   await this.getProgramList()
  },
  methods: {
    async getProgramList() {
      this.$emit('loading', true)
      store.commit('SET_LOADING_STATUS', true)

      await store.dispatch('programs/fetchProgramList')

      store.commit('SET_LOADING_STATUS', false)
      this.$emit('loading', false)
    },
  },
}
</script>

<style scoped>
    .message-container {
        position: absolute;
        font-size: 66px;
        font-weight: 700;
        color: white;
        text-align: center;
        width: 100%;
    }
</style>
